<template>
    <div
        ref="root"
        class="io-tooltip"
    >
        <slot></slot>
        <div data-ref="title">
            <slot name="title"></slot>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { Tooltip } from 'bootstrap';

import {
  onMounted,
  ref,
} from 'vue';

const props = withDefaults(defineProps<{
  trigger?:
      'click'
      | 'hover'
      | 'focus'
      | 'manual'
      | 'click hover'
      | 'click focus'
      | 'hover focus'
      | 'click hover focus'
  isError?: boolean
}>(), {
  trigger: 'hover focus',
});

const root = ref<InstanceType<typeof HTMLElement>>();
const tooltip = ref<Tooltip | null>(null);

onMounted(() => {
  const title = root.value?.querySelector('[data-ref="title"]');

  if (root.value && title) {
    tooltip.value = new Tooltip(root.value, {
      html: true,
      title: title.innerHTML,
      customClass: props.isError ? 'is-error' : '',
      trigger: props.trigger,
    });

    title.remove();
  }
});
</script>

<style lang="scss">
@import "src/scss/component-helpers";

$tooltip-color: $body-color;
$tooltip-bg: $white;
$tooltip-border-radius: 10px;
$tooltip-opacity: 1;
$tooltip-margin: 0;

$tooltip-arrow-width: 1em;
$tooltip-arrow-height: .68em;
$tooltip-arrow-color: var(--color-brand-primary);

@import "~bootstrap/scss/tooltip";

.io-tooltip {
  display: inline-block;
  cursor: help;
}

.tooltip[role="tooltip"] {
  z-index: 20002 !important;
  .tooltip {
    &-inner {
      @include poppins;
      @include font-weight-fix;
      @include font-small;
      max-width: calc(100vw - 40px);
      width: 480px;
      font-weight: 700;
      padding: 1em 1em 1.5em 1em;
      box-shadow: 0 2px 4px rgba(0, 0, 0, .15);
    }

    &-arrow {
      @include font-small;
    }
  }

  &.is-error .tooltip-inner {
    width: auto;
    max-width: 480px;
    min-width: 60px;
    padding: .5em 1em;
    color: $error-primary;
    font-size: 12px;
    font-weight: 300;
  }
}
</style>
